import {modelProduct} from './model-products.js';
export const isWatchProfile=profile=>['qtracker-care-watch','wonlex-ct30-pro','wonlex-ct10t'].includes(modelProduct(profile)?.id);
// Apply only to product copy, never to a person's name or user-authored messages.
export function watchText(text,watch,locale='da-DK'){
 if(!watch||typeof text!=='string')return text;
 const pairs=locale==='da-DK'?[['Armbåndets','Urets'],['armbåndets','urets'],['Armbåndet','Uret'],['armbåndet','uret'],['Armbånd','Ur'],['armbånd','ur']]:[['Bracelets','Watches'],['bracelets','watches'],['Bracelet','Watch'],['bracelet','watch']];
 return pairs.reduce((s,[before,after])=>s.replaceAll(before,after),text);
}
